import { t } from '@framework/i18n/intl/i18next.ts';
import { Typography } from 'antd';

const { Text } = Typography;

interface ISelectionCounterProps {
  selectedCount: number;
  totalCount: number;
}

/**
 * Contatore delle selezioni attive rispetto al totale visibile.
 * Visibile solo nella selezione multipla.
 */
export function SelectionCounter({
  selectedCount,
  totalCount,
}: ISelectionCounterProps) {
  const selectionCounterLabel = t(
    'widgets.advanced-multi-select.selection-counter',
    '{{selectedCount}} selezionati / {{totalCount}} totali',
    { selectedCount, totalCount },
  );

  return (
    <Text type="secondary" style={{ fontSize: 13 }}>
      {selectionCounterLabel}
    </Text>
  );
}
